import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, combineLatest } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { LoaderService } from '../../api/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './app-loader.component.html',
  styleUrls: ['./app-loader.component.css'],
  standalone: true,
})
export class AppLoaderComponent implements OnInit, OnDestroy {
  @Input() scope: 'screen' | 'container' = 'container';

  show = false;
  active = false;

  private destroy$ = new Subject<void>();

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.registerScope(this, this.scope === 'screen');

    combineLatest([this.loaderService.status, this.loaderService.activeScope$])
      .pipe(
        takeUntil(this.destroy$),
        map(([loading, activeScope]) => ({
          loading,
          active: activeScope === this,
        }))
      )
      .subscribe(({ loading, active }) => {
        this.active = active;
        this.show = loading && active;
      });
  }

  blockScroll(event: Event): void {
    if (this.show) {
      event.preventDefault();
    }
  }

  ngOnDestroy(): void {
    this.loaderService.releaseScope(this);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
